// Variant labels based on category
// snacks (fries/popcorn/onion rings) and drinks (mojitos) use صغير/كبير
// sandwiches use ساندوتش/وجبة when meal_price exists

const MEAL_CATEGORIES = new Set(["burgers", "sandwiches"]);

export function variantLabels(category) {
    if (MEAL_CATEGORIES.has(category)) {
        return { small: "ساندوتش", large: "وجبة" };
    }
    return { small: "صغير", large: "كبير" };
}

export function variantLabelOf(category, variant) {
    const labels = variantLabels(category);
    return variant === "meal" ? labels.large : labels.small;
}
